import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "@web/route-services/root/AppContext";

export const useChatCharactersQuery = (chatID: number) => {
  const { access } = useAppContext();

  return useQuery({
    queryKey: ["chatCharacters", chatID],
    queryFn: async () => {
      const chars = await access.character.getByChatID(chatID);
      const map = new Map(chars.map((c) => [c.id, c]));
      return map;
    }
  });
};
